import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getNextIncrementValue = createAsyncThunk(
  'general/getNextIncrementValue',
  async (type, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/general/increment/${type}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getNextIncrementValue;
